import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PaymentOrder } from '../../types/server-types';
import { http } from '../http';
import { CacheKeys } from './cache-configuration';

export const usePaymentOrders = (): UseQueryResult<PaymentOrder[]> => {
  return useQuery({
    queryKey: [CacheKeys.PAYMENT_ORDERS],
    queryFn: () => http.getPaymentOrders(),
  });
};

export const usePaymentOrder = (id: string): UseQueryResult<PaymentOrder> => {
  return useQuery({
    queryKey: [CacheKeys.PAYMENT_ORDER, id],
    queryFn: () => http.getPaymentOrder(parseInt(id)),
  });
};
